/**
 * desc 垂直步骤条
 * @params currentShow: 进行到某一步
 * @params progressData: 标题[]
 * @params propsClassName: 步骤条样式
 * */
import React, { Component } from 'react';
import { Steps } from 'antd';
const { Step } = Steps;
export default class ProgressBar extends Component {
    render() {
        const { currentShow, progressData, propsClassName } = this.props;
        return (<Steps progressDot direction="vertical" current={currentShow} className={propsClassName} size="small">
            {progressData.map((v, i) => (<Step {...v} key={i}/>))}
      </Steps>);
    }
}
